/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'

interface Props {
  datos: any[]
  loading: boolean
  getData: (data: any) => void
  formValue: any
  total: number
}

const TableReportCamasPreferentes: FC<Props> = ({datos, loading, getData, formValue, total}) => {
  const {setPagination, pagination, updateTable, setUpdateTable, clearTable, setClearTable} =
    useKTable()

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getData({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getData({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (formValue) {
      getData({pageNumber: pagination.currentPage, size: pagination.perPage})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setPagination({...pagination, totalResults: total})
  }, [total])

  // Definir columnas específicas para el reporte
  const columns: Column<any>[] = useMemo(() => {
    return [
      {
        Header: (props: any) => (
          <KTableHeader
            tableProps={props}
            title='Razón Social Empresa Contratista'
            className='min-width-105px'
            searcheable
            name='RazonSocial'
          />
        ),
        accessor: 'RazonSocialEmpresaContratista',
      },
      {
        Header: (props: any) => (
          <KTableHeader
            tableProps={props}
            title='RUC Empresa Contratista'
            className='min-width-100px'
            searcheable
            name='RUC'
          />
        ),
        accessor: 'RucEmpresaContratista',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='DNI' searcheable name='DNI' />
        ),
        accessor: 'NumeroDni',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='Nombres' searcheable name='Nombres' />
        ),
        accessor: 'Nombres',
      },
      {
        Header: (props: any) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Paterno'
            searcheable
            name='ApellidoPaterno'
          />
        ),
        accessor: 'ApellidoPaterno',
      },
      {
        Header: (props: any) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Materno'
            searcheable
            name='ApellidoMaterno'
          />
        ),
        accessor: 'ApellidoMaterno',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='Módulo' searcheable name='Modulo' />
        ),
        accessor: 'ModuloCodigo',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='Habitación' searcheable name='Habitacion' />
        ),
        accessor: 'HabitacionCodigo',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='Cama' searcheable name='CamaCodigo' />
        ),
        accessor: 'CamaCodigo',
      },
      {
        Header: (props: any) => (
          <KTableHeader tableProps={props} title='Cargo' searcheable name='Cargo' />
        ),
        accessor: 'Cargo',
      },
    ]
  }, [])

  if (loading && datos.length === 0) {
    return (
      <KTCard shadow className='m-5'>
        <KTableLoading />
      </KTCard>
    )
  }

  return (
    <>
      <KTable showButtons={datos.length > 0} columns={columns} data={datos || []} />
    </>
  )
}

const TableReportCamasPreferentesWrapper: FC<Props> = (props) => {
  return (
    <KTableProvider>
      <TableReportCamasPreferentes {...props} />
    </KTableProvider>
  )
}

export {TableReportCamasPreferentesWrapper as TableReportCamasPreferentes}
